const routes = [
  {
    path: "/manutencao-tipo-lotacao",
    name: "manutencao-tipo-lotacao",
    meta: {
      allowedPermissions: ["tipo_lotacao_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoTipoLotacao/ManutencaoTipoLotacaoHome.vue"),
  },

  {
    path: "/manutencao-tipo-lotacao/novo",
    name: "manutencao-tipo-lotacao-novo",
    meta: {
      allowedPermissions: ["tipo_lotacao_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoTipoLotacao/ManutencaoTipoLotacaoCad.vue"),
  },

  {
    path: "/manutencao-tipo-lotacao/editar/:id",
    name: "manutencao-tipo-lotacao-editar",
    meta: {
      allowedPermissions: ["tipo_lotacao_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoTipoLotacao/ManutencaoTipoLotacaoEdit.vue"),
  },
];

export default routes;
